import pkg from 'google-libphonenumber';

const { PhoneNumberUtil, PhoneNumberType } = pkg;

const phoneUtil = PhoneNumberUtil.getInstance();

/**
 * Phone number validation methods
 */
export const PHONE = {

  /**
   * Validates a belgian phone number
   *
   * @see https://fr.wikipedia.org/wiki/Liste_des_pr%C3%A9fixes_t%C3%A9l%C3%A9phoniques_en_Belgique
   * @see https://en.wikipedia.org/wiki/Telephone_numbers_in_Belgium
   * @see https://www.bipt.be/operators/publication/database-with-reserved-and-allocated-numbers
   *
   * @param {number} value Phone number to validate
   * @param {boolean} includeNonGeographicNumbers Include non geographic numbers as valid
   *
   * @returns Boolean
   */
  BE: (value, includeNonGeographicNumbers = false) => {
    if (includeNonGeographicNumbers === false && /^(07[08]|0800|090[012345679])/.test(value) === true) {
      return false;
    }
    try {
      return phoneUtil.isValidNumber(phoneUtil.parse(value, 'BE'));
    } catch (e) {
      return false;
    }
  },
};

/**
 * Fixed phone number validation methods
 */
export const FIXED_PHONE = (value, isoCode = 'BE') => {
  try {
    return phoneUtil.getNumberType(phoneUtil.parse(value, isoCode)) === PhoneNumberType.FIXED_LINE;
  } catch (e) {
    return false;
  }
};

/**
 * Mobile phone number validation methods
 */
export const MOBILE_PHONE = (value, isoCode = 'BE') => {
  try {
    return phoneUtil.getNumberType(phoneUtil.parse(value, isoCode)) === PhoneNumberType.MOBILE;
  } catch (e) {
    return false;
  }
};
